export default __webpack_public_path__ + "static/media/upload_gray.954d8fc3.svg";